import { API } from '../../../backend';
// import config from '../../../config';
import client from '../../../clients';
import { objectToQueryString } from '../../../lib/utils';

export const getAllProfileByUser = (userId, token, query) => {
  let str=objectToQueryString(query)
  return fetch(`${API}/profiles/${userId}?${str}`,{
    method: 'GET',
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`
    }
  }).then(response => {
    return response.json();
  }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
};


export const updateUserLookup = (userId, token, body) => {
  return fetch(`${API}/update/userLookup/${userId}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "content-type":"application/json",
      Authorization: `Bearer ${token}`
    },
    body:JSON.stringify(body)
  })
  .then(response => {
    return response.json();
  })
  .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const updateUserProfile = (userId, token, gymProfileImage) => {
  return fetch(`${API}/user/profile/update/${userId}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: gymProfileImage
  }).then(response => {
    return response.json();
  }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}